import { UniqueWithinTypeEncode } from './';

export const cacheRedirects = {
  Query: {
    work: (_, { workId }, { getCacheKey }) =>
      getCacheKey({
        __typename: 'Work',
        id: UniqueWithinTypeEncode('Work', workId)
      })
  }
};
